import React from 'react';
import FBPixel from '../FBPixel';

type FBPixelContextValue = {
  pixelID?: string | null;
  FBPixel: typeof FBPixel;
  FBPixelInitialized: boolean;
};

const FBPixelContext = React.createContext<FBPixelContextValue>({} as FBPixelContextValue);

export const FBPixelContextProvider: React.FC<{
  pixelID?: string | null;
  isAcceptedCookies: boolean;
  children: React.ReactNode;
}> = ({ children, pixelID, isAcceptedCookies }) => {
  const [initialized, setInitialized] = React.useState(false);

  React.useEffect(() => {
    if (pixelID && !initialized) {
      FBPixel.init(pixelID);
      isAcceptedCookies ? FBPixel.grantConsent() : FBPixel.revokeConsent();
      setInitialized(isAcceptedCookies);
    }
  }, [initialized, isAcceptedCookies, pixelID]);

  return (
    <FBPixelContext.Provider
      value={{
        pixelID,
        FBPixel,
        FBPixelInitialized: initialized,
      }}
    >
      {children}
    </FBPixelContext.Provider>
  );
};

export const useFBPixelContext = (): FBPixelContextValue => React.useContext(FBPixelContext);
